import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@fortawesome/fontawesome-free/css/all.css'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'fa'
  },
  theme: {
    themes: {
      light: {
        primary: '#8547AE',
        secondary: '#500B76',
        accent: '#AB7BC9'
      },
      dark: {
        primary: '#500B76',
        secondary: '#8547AE',
        accent: '#AB7BC9'
      }
    },
    options: {
      customProperties: true
    }
  }
})
